import * as Types from './types';

interface AuthState {
  authenticated: boolean;
  showNotification: boolean;
  notificationType: string | null;
  notificationMessage: string | null;
  emailNotVerified: boolean;
  userId: string | null;
  email: string | null;
}

interface SignInPayload {
  userId: string;
  email: string;
}

export const initialState: AuthState = {
  authenticated: false,
  showNotification: false,
  notificationType: null,
  notificationMessage: null,
  emailNotVerified: false,
  userId: null,
  email: null,
};

export default (
  state: AuthState = initialState,
  action: { type: string; payload?: unknown },
): AuthState => {
  const { payload } = action;
  switch (action.type) {
    case Types.SIGN_IN_SUCCESS: {
      const p = payload as SignInPayload;
      return {
        ...state,
        authenticated: true,
        userId: p.userId,
        email: p.email,
      };
    }
    case Types.SIGN_IN_UNAUTHORIZED:
      return {
        ...state,
        showNotification: true,
        notificationType: 'ERROR',
        notificationMessage: payload as string,
      };
    case Types.SIGN_IN_INTERNAL_SERVER_ERROR:
      return {
        ...state,
        showNotification: true,
        notificationType: 'ERROR',
        notificationMessage: payload as string,
      };
    case Types.SIGN_IN_UNKNOWN_ERROR:
      return {
        ...state,
        showNotification: true,
        notificationType: 'ERROR',
        notificationMessage: payload as string,
      };
    case Types.SIGN_IN_PARTIAL_SUCCESS_EMAIL_NOT_VERIFIED: {
      const p = payload as SignInPayload;
      return {
        ...state,
        userId: p.userId,
        email: p.email,
        emailNotVerified: true,
      };
    }
    case Types.SIGN_IN_VERIFICATION_EMAIL_FAILED_TO_SEND:
      return {
        ...state,
        showNotification: true,
        notificationType: 'ERROR',
        notificationMessage: payload as string,
      };
    case Types.SIGN_OUT_SAGA:
      return initialState;
    default:
      return state;
  }
};
